import React, { useContext } from 'react';

import { Route, Routes } from '@gogame/screens';

import { ConversionPageDetailsRouteElement } from 'scenes/Gallery/ConversionPages/ConversionPages/ConversionPageDetails/ConversionPageDetailsRouteElement';
import {
  VIEW_MODE_DATATABLE,
  VIEW_MODE_TILES,
} from 'scenes/Gallery/ConversionPages/constants';

import ConversionPagesTiles from './ConversionPagesTiles';
import PagesDataTableOriginal from './ConversionPagesDataTable';
import ConversionPagesDataTableContext, {
  ConversionPagesDataTableProvider,
  usePagesCount,
} from './ConversionPagesDataTableContext';

export {
  ConversionPagesDataTableContext,
  ConversionPagesDataTableProvider,
  usePagesCount,
};

export const ConversionPagesDataTable = ({ height, tabs, withTitle }) => {
  const { viewMode } = useContext(ConversionPagesDataTableContext);

  return (
    <React.Fragment>
      {
        {
          [VIEW_MODE_DATATABLE]: (
            <PagesDataTableOriginal
              height={height}
              tabs={tabs}
              withTitle={withTitle}
            />
          ),
          [VIEW_MODE_TILES]: (
            <ConversionPagesTiles
              height={height}
              tabs={tabs}
              withTitle={withTitle}
            />
          ),
        }[viewMode]
      }
      <Routes>
        <Route path={':id'} element={<ConversionPageDetailsRouteElement />} />
      </Routes>
    </React.Fragment>
  );
};
